import { render, staticRenderFns } from "./chiTietTraiCay.vue?vue&type=template&id=24b68c74&scoped=true&"
import script from "./chiTietTraiCay.vue?vue&type=script&lang=js&"
export * from "./chiTietTraiCay.vue?vue&type=script&lang=js&"
import style0 from "./chiTietTraiCay.vue?vue&type=style&index=0&id=24b68c74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b68c74",
  null
  
)

export default component.exports